import React from 'react';
import { Button } from '@/components/ui/button';

import type { OpenCandidatesActionFn, ProgramControlCommonProps, SubmitReportFn } from '../controlTypes';

type OliveProgramControlsProps = ProgramControlCommonProps & {
  isOliveProgram: boolean;
  isOliveVistaProgram: boolean;
  onOpenCandidatesAction: OpenCandidatesActionFn;
  onSubmitReport: SubmitReportFn;
};

export const OliveProgramControls = ({
  values,
  onFilterChange,
  actionRowClass,
  renderStandardActionButtons,
  renderReportActionLabel,
  isOliveProgram,
  isOliveVistaProgram,
  onOpenCandidatesAction,
  onSubmitReport,
}: OliveProgramControlsProps) => (
  <div className="mb-3 flex flex-wrap items-end justify-between gap-4 rounded-[var(--border-radius-medium)] border border-[var(--neutral-gray-40)] bg-white px-4 py-3">
    <div className="flex flex-wrap items-center gap-6">
      <div className="flex items-center gap-3">
        <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">
          Admitted
        </div>
        <div className="flex items-center gap-4 text-xs text-[var(--neutral-gray-120)]">
          <label className="flex items-center gap-1.5">
            <input
              type="radio"
              name="olive-admitted"
              value="all"
              checked={values.admittedFilter === 'all'}
              onChange={() => onFilterChange('admittedFilter', 'all')}
            />
            All
          </label>
          <label className="flex items-center gap-1.5">
            <input
              type="radio"
              name="olive-admitted"
              value="y"
              checked={values.admittedFilter === 'y'}
              onChange={() => onFilterChange('admittedFilter', 'y')}
            />
            Yes
          </label>
          <label className="flex items-center gap-1.5">
            <input
              type="radio"
              name="olive-admitted"
              value="n"
              checked={values.admittedFilter === 'n'}
              onChange={() => onFilterChange('admittedFilter', 'n')}
            />
            No
          </label>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">
          Graduated
        </div>
        <div className="flex items-center gap-4 text-xs text-[var(--neutral-gray-120)]">
          <label className="flex items-center gap-1.5">
            <input
              type="radio"
              name="olive-graduated"
              value="y"
              checked={values.graduatedFilter === 'y'}
              onChange={() => onFilterChange('graduatedFilter', 'y')}
            />
            Yes
          </label>
          <label className="flex items-center gap-1.5">
            <input
              type="radio"
              name="olive-graduated"
              value="n"
              checked={values.graduatedFilter === 'n'}
              onChange={() => onFilterChange('graduatedFilter', 'n')}
            />
            No
          </label>
        </div>
      </div>
    </div>

    <div className={actionRowClass}>
      {renderStandardActionButtons()}
      <Button type="button" variant="outline" size="sm" className="h-8" onClick={() => onOpenCandidatesAction('court-list-report')}>
        {renderReportActionLabel('Court List')}
      </Button>

      {isOliveProgram && (
        <>
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-8"
            onClick={() =>
              onSubmitReport({
                action: 'acute-bed-report',
                download: '1',
                report_id: '1',
              })
            }
          >
            {renderReportActionLabel('Acute Bed Report 1')}
          </Button>
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-8"
            onClick={() =>
              onSubmitReport({
                action: 'acute-bed-report',
                download: '1',
                report_id: '2',
              })
            }
          >
            {renderReportActionLabel('Acute Bed Report 2')}
          </Button>
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-8"
            onClick={() =>
              onSubmitReport({
                action: 'all-report',
                download: '1',
              })
            }
          >
            {renderReportActionLabel('All Candidates List')}
          </Button>
        </>
      )}

      {isOliveVistaProgram && (
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="h-8"
          onClick={() =>
            onSubmitReport({
              action: 'ovista-report',
              download: '1',
              report_id: '1',
            })
          }
        >
          {renderReportActionLabel('Sub-Acute Report All Fields')}
        </Button>
      )}
    </div>
  </div>
);
